import { Card, CardActionArea, CardContent, SxProps, Theme, Typography } from '@mui/material';
import { red, amber, green, blue, orange, grey } from '@mui/material/colors';
import NumberFormat from 'react-number-format';
import { AppBadge } from 'shared/components/app-badge';
import { useQuoteState } from 'shared/contexts';

type colors = 'red' | 'amber' | 'green' | 'blue' | 'orange' | 'grey';
interface MarginButtonProps {
  margin: number;
  label: string;
  onClick: (param: any) => void;
  disabled: boolean;
  color: colors;
  bold?: boolean;
  badge?: string;
}
interface StylePropsI {
  color: colors;
  bold?: boolean;
  editMode: boolean;
  hasMargin: boolean;
}

const colorMap: Record<colors, { light: string; main: string }> = {
  red: {
    main: red[500],
    light: red[50],
  },
  amber: {
    main: amber[600],
    light: amber[50],
  },
  green: {
    main: green[500],
    light: green[50],
  },
  blue: {
    main: blue[600],
    light: blue[50],
  },
  orange: {
    main: orange[600],
    light: orange[50],
  },
  grey: {
    main: grey[500],
    light: grey[50],
  },
};

const rootStyles = (props: StylePropsI) => (theme: Theme) => ({
  width: '200px',
  backgroundColor: (props.editMode && props.hasMargin && colorMap[props.color].light) || 'inherit',
});
const colorStyles = (props: StylePropsI) => (theme: Theme) => ({
  color: (props.editMode && props.hasMargin && colorMap[props.color].main) || 'inherit',
});
const contentStyles: SxProps<Theme> = (theme: Theme) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
});

export function MarginButton({ margin, label, onClick, disabled, color, badge, bold = false }: MarginButtonProps) {
  const { editMode } = useQuoteState();
  const hasMargin = Boolean(margin);
  const hasBadge = Boolean(badge);
  const styleProp: StylePropsI = { color, editMode, bold, hasMargin };
  return (
    <AppBadge invisible={!hasBadge} badgeContent={badge || ''}>
      <Card sx={rootStyles(styleProp)} square={true}>
        <CardActionArea onClick={onClick} disabled={disabled || !margin}>
          <CardContent sx={contentStyles}>
            <Typography variant='inherit'>{label}</Typography>
            <Typography sx={colorStyles(styleProp)} variant='h6'>
              {hasMargin ? (
                <NumberFormat value={Number(margin * 100).toFixed(2)} suffix='%' displayType='text' />
              ) : (
                '0%'
              )}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </AppBadge>
  );
}
